import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';

const LanguageContext = createContext({
  lang: 'es',
  setLang: () => {},
  toggleLang: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('es');
  const toggleLang = useCallback(
    () => setLang((prev) => (prev === 'es' ? 'en' : 'es')),
    []
  );

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggleLang,
    }),
    [lang, toggleLang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
